import React, { useState, useEffect, Fragment } from "react";
import InsertText from '../../../../pages/integration/data/insert-text-at-cursor';
import {
    Row,
    Input,
    Label,
    Button,
    CustomInput,
    ModalBody,
    ModalFooter,
    Card,
    CardBody,
} from 'reactstrap';
import { Colxx, Separator } from '../../../../../../components/common/CustomBootstrap';
const MyTextbox = React.forwardRef(({ contents, onChange }, ref) => {
    let myContents = contents;

    return (
        <Input
            type="textarea"
            ref={ref}
            name="messageText"
            onChange={onChange}
            placeholder="What to send"
            value={myContents}
            rows={5}
        />
    );
});
const placeholders = [
    { value: "{{FIRST_NAME}}" },
    { value: "{{LAST_NAME}}" },
    { value: "{{CHECK_IN}}" },
]
export default function WhatsAppAction({ visible, toggle, submit, inputData }) {
    const textbox = React.createRef();
    const [selectedTokens, setSelectedTokens] = useState([]);
    const [whatsappInputData, setWhatsappInputData] = useState({
        type: "WhatsApp",
        messageText: "",
        buttons: []
    });
    const [buttonList, setButtonList] = useState([
        { value: "Guest Service", text: "Guest Service", checked: false },
        { value: "Add-on's", text: "Add-on's", checked: false }
    ]);
    const [ownButtonList, setOwnButtonList] = useState([]);
    const [isButtonAdd, setIsButtonAdd] = useState(true);
    useEffect(() => {
        const but = buttonList.filter((i) => i.checked === true);
        if (but.length > 4) {
            setIsButtonAdd(false);
        }
        const appAddonsArr = buttonList
            .filter((elem) => elem.checked === true)
            .map((elem) => ({
                text: elem.text,
                value: elem.value,
            }));
        setWhatsappInputData({
            ...whatsappInputData,
            buttons: appAddonsArr
        });
    }, [buttonList]);
    useEffect(() => {
        if (inputData && inputData.length > 0) {
            var data = inputData[0];
            if (data !== undefined) {
                const systemButton = data.buttons.filter((item) => item.value === "Guest Service" || item.value === "Add-on's")
                    .map((i) => i);
                const but = data.buttons.filter((item) => item.value !== "Guest Service" && item.value !== "Add-on's")
                    .map((item) => item);
                const values = [];
                buttonList.map((i) => {
                    systemButton.map((item) => {
                        if (i.value === item.value) {
                            values.push({
                                text: item.text,
                                value: item.value,
                                checked: item.checked
                            })
                        } else {
                            values.push({
                                text: i.text,
                                value: i.value,
                                checked: i.checked
                            })
                        }
                    })
                });
                setButtonList(values);
                setOwnButtonList(but);
                setWhatsappInputData(data);
            }
        }
    }, [inputData]);

    function generateRandomColor(index) {
        var arr = [
            'primary',
            'secondary',
            'info',
            'success',
            'warning',
            'danger',
            'light',
            'dark',
        ];
        return arr[Math.floor(Math.random() * arr.length)];
    }
    const handleChange = (evt) => {
        let s = evt.target.value;
        let tok = [];
        placeholders.map((items) => {
            if (s.includes(items.value)) {
                tok.push({
                    value: items.value
                })
            }
        });
        setSelectedTokens(tok);
        setWhatsappInputData({ ...whatsappInputData, messageText: s });
    };
    const handleInsert = (name) => {
        var text = document.getElementsByName("messageText");
        text[0].focus();
        InsertText(textbox.current, name);
    };

    const handleButtonChange = (e) => {
        const values = buttonList.map((elem) => {
            if (elem.value === e.target.name) {
                elem.text = e.target.value;
            }
            return {
                ...elem,
            };
        });
        setButtonList(values);
    };

    const handleOwnButtonChange = (e, index) => {
        const values = [...ownButtonList];
        if (e.target.name === "text") {
            values[index].text = e.target.value;
        }
        else if (e.target.name === "value") {
            values[index].value = e.target.value;
        }
        setOwnButtonList(values);
    };
    const handleRoleChange = (e) => {
        const values = buttonList.map((elem) => {
            if (elem.value === e.target.value) {
                if (elem.checked) {
                    elem.checked = false;
                } else if (!elem.checked) {
                    elem.checked = true;
                }
            }
            return {
                ...elem,
            };
        });
        setButtonList(values);
    };
    const handleOwnRoleChange = (e) => {
        const values = ownButtonList.map((elem) => {
            if (elem.value === e.target.value) {
                if (elem.checked) {
                    elem.checked = false;
                } else if (!elem.checked) {
                    elem.checked = true;
                }
            }
            return {
                ...elem,
            };
        });
        setOwnButtonList(values);
    };
    const handleAddButton = (e) => {
        const values = [...ownButtonList];
        values.push({ value: "", text: "", checked: false });
        setOwnButtonList(values);
        const but = buttonList.filter((i) => i.checked === true);
        let val = but.length <= 2 ? (but.length + values.length) : values.length;
        if (val === 4) {
            setIsButtonAdd(false);
        }
    };
    const handleRemoveOwnButton = (index) => {
        const values = [...ownButtonList];
        values.splice(index, 1);
        setOwnButtonList(values);
        const but = buttonList.filter((i) => i.checked === true);
        let val = but.length < 2 ? (but.length + values.length) : values.length;
        if (val < 4) {
            setIsButtonAdd(true);
        }
    }

    const handleSubmit = () => {
        const buttonselect = buttonList.filter((i) => i.checked === true);
        var button = [...buttonselect, ...ownButtonList];
        var body = {
            ...whatsappInputData,
            buttons: button
        };
        submit(body);
    }
    return (
        <Fragment>
            <ModalBody>
                {whatsappInputData && (
                    <Card>
                        <CardBody>
                            <Row>
                                <Colxx sm={12} style={{ marginBottom: "10px" }}>
                                    <Label>What to Send</Label>
                                    <MyTextbox
                                        contents={whatsappInputData.messageText}
                                        ref={textbox} onChange={handleChange} />
                                </Colxx>
                                <Colxx sm={12} style={{ marginBottom: "10px" }}>
                                    <Label>Insert Placeholder</Label>
                                    <div style={{ display: "flex", flexWrap: "wrap", justifyContent: "center" }}>
                                        {placeholders.map((token, index) => {
                                            return (
                                                <div key={index} style={{ marginRight: "1.5px" }}>
                                                    <Button
                                                        color={generateRandomColor(index)}
                                                        className="mb-2"
                                                        outline
                                                        size="xs"
                                                        onClick={() => handleInsert(token.value)}
                                                    >{token.value}</Button>
                                                </div>
                                            );
                                        })}
                                    </div>
                                </Colxx>
                                <Colxx sm={12} style={{ marginBottom: "10px" }}>
                                    <div className="text-center mb-5">
                                        <Label>Buttons</Label>
                                        <Separator /></div>
                                    <Row>
                                        <Colxx sm={6}>
                                            <Label>Button Text</Label>
                                        </Colxx>
                                        <Colxx sm={6}>
                                            {buttonList.length > 0 &&
                                                buttonList[0].checked === true ||
                                                ownButtonList.length > 0 ?
                                                <Label>Button Url or Value</Label> : null
                                            }
                                        </Colxx>
                                    </Row>
                                    {buttonList.map((elem, index) => (
                                        <Row key={`buttonRow~${index}`}>
                                            <Colxx xxs="6" className="mt-1">
                                                <CustomInput
                                                    key={`buttonChk~${index}`}
                                                    type="checkbox"
                                                    value={elem.value}
                                                    id={elem.value}
                                                    onChange={(e) => handleRoleChange(e)}
                                                    checked={elem.checked}
                                                >
                                                    {elem.text}
                                                </CustomInput>
                                            </Colxx>
                                            <Colxx xxs="6" className="mt-1">
                                                {elem.checked ? (
                                                    <Input
                                                        key={`buttontText~${index}`}
                                                        type="text"
                                                        value={elem.text}
                                                        name={elem.value}
                                                        onChange={handleButtonChange}
                                                    />
                                                ) : null}
                                            </Colxx>
                                        </Row>
                                    ))}
                                    {ownButtonList.length > 0 && ownButtonList.map((item, i) => (
                                        <Fragment key={i}>
                                            <Row className="mb-3">
                                                <Colxx xxs={6} className="mt-1 d-flex">
                                                    <CustomInput
                                                        key={`buttonChk~${i}`}
                                                        type="checkbox"
                                                        value={item.value}
                                                        id={item.value}
                                                        onChange={(e) => handleOwnRoleChange(e)}
                                                        checked={item.checked}
                                                    ></CustomInput>
                                                    <Input
                                                        type="text"
                                                        value={item.text}
                                                        name="text"
                                                        onChange={(e) => handleOwnButtonChange(e, i)}
                                                    />
                                                </Colxx>
                                                <Colxx xxs={5} className="mt-1">
                                                    <Input
                                                        type="text"
                                                        value={item.value}
                                                        name="value"
                                                        onChange={(e) => handleOwnButtonChange(e, i)}
                                                    />
                                                </Colxx>
                                                <Colxx xxs={1} className="mt-1">
                                                    <Button
                                                        onClick={() => handleRemoveOwnButton(i)}
                                                        color="secondary"
                                                        size="xs"
                                                        outline
                                                        style={{ margin: '5px' }}
                                                    >
                                                        -
                                                    </Button>
                                                </Colxx>
                                            </Row>
                                        </Fragment>
                                    ))}
                                    {isButtonAdd && buttonList.length < 4 && (
                                        <Button
                                            onClick={(e) => handleAddButton(e)}
                                            color="primary"
                                            size="xs"
                                            outline
                                            style={{ margin: '6px', marginTop: "20px" }}
                                        >
                                            + Add Button
                                        </Button>
                                    )}
                                </Colxx>
                            </Row>
                        </CardBody>
                    </Card>
                )}
            </ModalBody>
            <ModalFooter>
                <Button color="primary"
                    onClick={handleSubmit}
                >
                    Create
                </Button>
                <Button color="secondary"
                    onClick={toggle}
                >
                    Cancel
                </Button>
            </ModalFooter>
        </Fragment>
    )
}